'use strict';

var lang = window.wooGlobal.language;

// event when the user change the review date (+ analytics event)
$('#dashboard .date-dropdown .dropdown-value').on('change', function () {
  var url = '/' + lang + '/review/' + window.currentWebsite + '/' + $(this).val();
  window.location = url;
});
